export default class Menu {
	constructor () {

		console.log('Menu');

		this.btnOpen = document.getElementById('btn_open_menu');
		this.btnClose = document.getElementById('btn_close_menu');
		this.container = document.getElementById('menu_container');

		this.bindEvents();
	}

	bindEvents () {

		this.btnOpen.addEventListener('click', this.open.bind(this));
		this.btnClose.addEventListener('click', this.close.bind(this));

	}

	open () {
		if ( !this.container.classList.contains('is-visible') )
		{
			this.container.classList.add('is-visible');
		}
	}

	close () {
		if ( this.container.classList.contains('is-visible') )
		{
			this.container.classList.remove('is-visible');
		}
	}

}